/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_SCHEDULES = gql`
  query GetSchedules($filters: ScheduleFilterInput, $options: GetManyOptions) {
    getSchedules(filters: $filters, options: $options) {
      content {
        id
        scheduleID
        attendeesCount
        maxAttendees
        timeZoneOffset
        eventStartTime
        eventEndTime
      }
    }
    getCurrencyExchangeRate {
      eventTimeZone {
        tmz
        abbrevation
        offset
      }
    }
  }
`;
